// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireQuestionChoiceOptionFragmentDoc } from './option/QuestionnaireQuestionChoiceOption.fragment.generated';
export const QuestionnaireQuestionChoiceFragmentDoc = gql`
    fragment questionnaireQuestionChoice on QuestionnaireQuestionChoice {
  id
  title
  multiple
  required
  options {
    ...questionnaireQuestionChoiceOption
  }
}
    ${QuestionnaireQuestionChoiceOptionFragmentDoc}`;